/**
 * Функция для получения displayName компонента
 *
 * @export
 * @param {React.ComponentType} Component
 * @returns {string}
 */
export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}